import * as React from 'react';
import { VFC } from 'react';
import { ApplicationContext } from '../../reactContexts/applicationContext';
import { SuburbanShowcase } from '../../SuburbanComponents/SuburbanShowcase';
import { IShowcase } from '../../types/showcase/props';
import { ISuburbanData } from '../../types/suburban/data';

export const SuburbanShowcaseContainer: VFC<Omit<IShowcase, 'data'>> = props => {
  const { config } = React.useContext(ApplicationContext);

  const data =
    config.get<ISuburbanData>('mortgageLanding.suburbanData') || ({ mortgage: { options: {} } } as ISuburbanData);

  return <SuburbanShowcase {...props} data={data.mortgage.options} />;
};
